var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigAdmins = function SvgConfigAdmins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "config_admins_svg__Capa_2",
    viewBox: "0 0 35.03 43.71"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "config_admins_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.51 39.63c7.89 0 14.29-6.48 14.29-14.47s-6.4-14.47-14.29-14.47S3.22 17.17 3.22 25.16s6.4 14.47 14.29 14.47",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.64h7.52v35.03h-7.52z",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.64h7.52v35.03h-7.52z",
    transform: "rotate(45 17.52 25.157)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.64h7.52v35.03h-7.52z",
    transform: "rotate(90 17.515 25.155)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.64h7.52v35.03h-7.52z",
    transform: "rotate(135 17.516 25.157)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.51 20.01c4.53 0 8.2-3.72 8.2-8.3s-3.67-8.3-8.2-8.3-8.2 3.72-8.2 8.3 3.67 8.3 8.2 8.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.67 21.02h8.09c4.01 0 7.27 3.29 7.27 7.36v11.69c0 2.01-1.61 3.64-3.59 3.64H10c-1.99 0-3.59-1.63-3.59-3.64V28.38c0-4.06 3.25-7.36 7.27-7.36Z",
    fill: "#510c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 21.02c0 2.31-4.13 11.98-4.13 11.98s-4.13-9.67-4.13-11.98h8.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 10.28s3.1.73 6.99-.59c0 0 .53.73 2.21.39s2.64-1.8 2.64-1.8.91 1.99 4.37 2.48c0 0 .19 1.3-.19 2.92 0 0 1.88-2.29 1.53-5.92-.33-3.39-2.72-5.31-4.79-4.97 0 0-3.76-4.39-9.77-2.18-7.46 2.76-5.35 11.41-2.99 12.47 0 0-.16-1.3.01-2.82Z",
    fill: "#510c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.95 24.45-1.38-1.26-1.23 1.26.75.75-.75 4.44L17.72 33l1.35-3.29-.84-4.54z",
    fill: "#ff1b51"
  }))));
};
export default SvgConfigAdmins;